import { is, sample, createStore } from 'effector';
export function once(unitOrConfig) {
  var source;
  var reset;
  if (is.unit(unitOrConfig)) {
    source = unitOrConfig;
  } else {
    ({
      source,
      reset
    } = unitOrConfig);
  }
  var $canTrigger = createStore(true, {
    name: "$canTrigger",
    sid: "-oewyj9"
  });
  var trigger = sample({
    and: [{
      source,
      filter: $canTrigger
    }],
    or: {
      name: "trigger",
      sid: "g04b8v"
    }
  });
  $canTrigger.on(trigger, () => false);
  if (reset) {
    $canTrigger.reset(reset);
  }
  return sample({
    and: [{
      clock: trigger
    }],
    or: {
      sid: "-owij98"
    }
  });
}